import React from "react";

const DocumentSvg = ({className}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
       className={className}
    >
      <path
        d="M15 9.14996V10.425C15 12.7875 13.65 13.8 11.625 13.8H4.875C2.85 13.8 1.5 12.7875 1.5 10.425V6.375C1.5 4.0125 2.85 3 4.875 3H6.9C6.8025 3.285 6.75 3.6 6.75 3.9375V6.86252C6.75 7.59002 6.99 8.20501 7.4175 8.63251C7.845 9.06001 8.46 9.30002 9.1875 9.30002V10.3425C9.1875 10.725 9.6225 10.9575 9.945 10.7475L12.1125 9.30002H14.0625C14.4 9.30002 14.715 9.24746 15 9.14996Z"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 3.9375V6.86252C16.5 7.98002 15.93 8.81996 15 9.14996C14.715 9.24746 14.4 9.30002 14.0625 9.30002H12.1125L9.945 10.7475C9.6225 10.9575 9.1875 10.725 9.1875 10.3425V9.30002C8.46 9.30002 7.845 9.06001 7.4175 8.63251C6.99 8.20501 6.75 7.59002 6.75 6.86252V3.9375C6.75 3.6 6.8025 3.285 6.9 3C7.23 2.07 8.07 1.5 9.1875 1.5H14.0625C15.525 1.5 16.5 2.475 16.5 3.9375Z"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5498 16.5H10.9498"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 13.7998V16.4998"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8716 5.4375H13.8784"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.772 5.4375H11.7788"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.67143 5.4375H9.67818"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DocumentSvg;
